var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 主办: 河北省应急管理厅 "),_c('br'),_vm._v(" 冀ICP备14020218号 冀公网安备 13011002000239号 ")])
}]

export { render, staticRenderFns }